import "./ContactUs.module.css";
import WebsiteHeader from "@/reusable_sections/Header";
import FindTheFlavor from "./sections/FindTheFlavor";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
import Hero from "./sections/Hero";
export default function ContactUsPage() {
  return <div>
      <WebsiteHeader />
      <Hero />
      <FindTheFlavor />
      <ContactUs />
      <Footer />
    </div>;
}